<section>
    <div class="page-title">
        <h2>{{ summaryPageData.header }}</h2>
    </div>
    <div class="table-content">
        <xm-addon-summary-table [addonLines]="addonLines" [lines]="lines" [pageData]="summaryPageData" [isGTP]="isGTP" [isMexCan]="isMexCan" [overallStatus]="overallStatus"></xm-addon-summary-table>
    </div>
    <addon-summary-pointers *ngIf="overallStatus === ProgressStatus.SUMMARY"></addon-summary-pointers>
    <xm-addon-loader [pageData]="loaderData" [percentage]="pollingPercentage" [overallStatus]="overallStatus" *ngIf="overallStatus !== ProgressStatus.SUMMARY"></xm-addon-loader>
    <div class="action" *ngIf="overallStatus === ProgressStatus.SUMMARY">
        <button *ngIf="summaryPageData.secondaryLinkLabel" class="xm-btn-link-light left-btn" (click)="onCancel()">{{
            summaryPageData.secondaryLinkLabel }}</button>
        <button 
            class="xm-btn-primary-light promise-btn" 
            (promiseClick)="onClickPrimary()" 
            [promiseBtn]="postAddRemovedAddonsPromise">
            <span>{{ primaryBtnLabel }}</span>
        </button>
    </div>
    <p class="error" *ngIf="hasApiError">{{ planData.content.failureData.apiError }}</p>
</section>
